import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-1 space-x-1"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_5 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-blue-400 text-[14px] align-middle mr-1" }, "info", -1)
const _hoisted_7 = { class: "text-sm text-gray-500 align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", {
            for: _ctx.id,
            class: "text-gray-800 tracking-wide text-[15px]"
          }, _toDisplayString(_ctx.label), 9, _hoisted_2),
          (!_ctx.optional)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.classes, "overflow-clip"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.hint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.hint), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}